export enum AuthType {
    GUEST = 'guest',
    REGISTERED = 'registered',
}
